export const CARD_NUMBER_FIELD_ID = 'pci-proxy-card-number';

export const CVV_FIELD_ID = 'pci-proxy-cvv';
